import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { usePermission } from '../../hooks/usePermission';
import { ParticipantDeleteModal } from './ParticipantDeleteModal';

interface Props {
  participantId: string;
  participantName: string;
}

export const ParticipantDeleteMenuItem = (props: Props) => {
  const { participantId, participantName } = props;
  const hasPermission = usePermission('delete', 'participant');

  return (
    <ChakraV3.MenuItem
      onClick={() => showModal(ParticipantDeleteModal, { participantId, participantName })}
      value='delete'
      disabled={!hasPermission}
      color='danger'
    >
      <FaRegTrashAlt />
      Delete
    </ChakraV3.MenuItem>
  );
};
